<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="diaparpre"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmdiaparpre" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 99%">
	<div class="p-col-12">
		<app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
						 [botonRegresar]="btnRegresar" [botonPrimero]="false" [botonAnterior]="false"
						 [botonSiguiente]="false" [botonUltimo]="false" [barraBotonesCRUD]="false"
						 [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
						 [barraBotones5]="false"
						 [botonBuscar]="false"
						 [botonBinocular]="true"
						 (signal)="manejarSenales($event)"></app-invmaebarra>
    </div>
</div>
    <div class="p-col-12">
        <p-tabView [(activeIndex)]="index" (activeIndexChange)="cambioTab()">
            <p-tabPanel header="Diario Partidas Presupuestaria">
                <div class="divgrups">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
                                    <p-calendar id="ENCDIAPAR_FECHA" [inputStyle]="{width: '100%', height: '20px'}"
                                    [(ngModel)]="condiaparpreService.encabezadoDiaParpreSelectarray[indicador].ENCDIAPAR_FECHA"
                                    [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                    (keydown)="cambio($event)">
                                </p-calendar>
                                </div>
                                <div class="p-col-1">
                                    <span>Año:</span>
                                </div>
                                <div class="p-col-1">
                                    <input pInputText type="text" size="4" id="ENCPARPRE_ANIO" 
                                        oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                        
                                        [(ngModel)]="condiaparpreService.encabezadoDiaParpreSelectarray[indicador].ENCPARPRE_ANIO"
                                        (keydown.enter)="setFocus($event)"
                                        autocomplete="off" [maxLength]="4">
                                </div>
                                <!-- <div class="p-col-1">
                                    <button class="littlebuttons"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="busquedaanioestado(condiaparpreService.encabezadoDiaParpreSelectarray[indicador].ENCPARPRE_ANIO)"></button>
                                </div> -->
    
                            </div>
                        </div>
                        <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Concepto:</span>
                                </div>
                                <div class="p-col-11">
                                    <input pInputText type="text" size="14" id="ENCDIAPAR_CONCEPTO"
                                        [(ngModel)]="condiaparpreService.encabezadoDiaParpreSelectarray[indicador].ENCDIAPAR_CONCEPTO"
                                        autocomplete="off" (input)="cambio($event)" [maxLength]="100">
                                </div>
                            </div>
                        </div>
                        <!-- <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Buscar número:</span>
                                </div>
                                <div class="p-col-11">
                                    <div class="p-col-1">
                                        <button class="littlebuttons"
                                            style="background-image: url(../../../assets/images/iconos/067-binocular.webp);"
                                            (click)="busquedanumero()"></button>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="divg" style="height: 650px">
                    <app-aggridsaci [width]="" [height]="600" [enableSorting]="false" [enableFilter]="true"
                        [rowData]="condiaparpreService.detdiaparprearray" [frameworkComponents]="frameworkComponents"
                        [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsDiaParpre"
                        [defaultColDef]="defaultColDefDiaParpre" [rowStyle]="rowStyle" [singleClickEdit]="false"
                        [botones]="true" (selected)="selectedDiaParpre($event)" (cambios)="cambio($event)"
                        [botonNuevo]="btnNuevoGrid"
                        [mostrarGuardar]="false"
				        [botonBorrar]="btnBorrarGrid" [botonRegresar]="btnCancelarGrid"
                        >
                    </app-aggridsaci>
                </div> 
            </p-tabPanel>
        </p-tabView>
    </div>
    <p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
        [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>
